import React from 'react';


const ContentImage = ({imageSrc, itemIdx}) => (
  <div className="my-10 flex justify-center items-center">
    <img className="max-w-1000" src={imageSrc} alt={`step-${itemIdx}`} />
  </div>
);

export default ContentImage;
